import OrderComplete from '../../components/pages/orders/OrderComplete.vue'

export default {
  components: {
    OrderComplete
  }
}
